import { api } from "./api";
export const addApprovalWorkFlowApi = (params) => {
  return api.post("/approval-flows", JSON.stringify(params));
};
export const getAllUsersByRoleIdApi = (params) => {
  return api.get(`/user/getAllUserDropdown?role_id=${params.role_id}`);
};
export const addOriginatorsApi = (params) => {
  return api.post("/approval-flows/originators", JSON.stringify(params));
};
export const getMainModulesApi = (params) => {
  return api.get("/template/mainModules/getAll");
};
export const getSubModulesApi = (params) => {
  return api.get(`/template/subModules/getAll?main_module_id=${params.module_id}`);
};
export const getColumnsApi = (params) => {
  return api.get(`/getColumnList?transaction_type=${params.transaction_type}`);
};
export const addDocumentsApi = (params) => {
  return api.post("/approval-flows/documents", JSON.stringify(params));
};
export const addStagesApi = (params) => {
  return api.post(`/approval-flows/stages`, JSON.stringify(params));
};
export const getApprovalListApi = (params) => {
  return api.get(`/approval-flows/user/get/approvallist?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&selectedColumn=${params.selectColumn}&value=${params.inputValue}`);
};
export const getApprovalAcceptanceApi = (params) => {
  return api.get(`/approval-flows/user/get/approvalStages/getById?request_id=${params.request_id}`);
};
export const approverActionApi = (params) => {
  return api.post(`/approval-flows/user/update/stage`,JSON.stringify(params));
};
/**
 * View / edit a single approval flow.
 *
 * getApprovalFlowById returns the flow plus its nested originators,
 * document_terms and stages, so one call fills every tab.
 * Note the route path is literally /approvalFlowId — the id travels in the
 * query string, not as a path segment.
 */
export const getApprovalFlowByIdApi = (params) => {
  return api.get(
    `/approval-flows/approvalFlowId?approvalFlowId=${params.approvalFlowId}`
  );
};
export const updateApprovalFlowApi = (params) => {
  return api.put(`/approval-flows/update`, JSON.stringify(params));
};
export const updateStagesApi = (params) => {
  return api.put(`/approval-flows/stages/update`, JSON.stringify(params));
};
export const updateDocumentsApi = (params) => {
  return api.post(`/approval-flows/documents/update`, JSON.stringify(params));
};

/**
 * GET /approval-flows/list — the approval flow definitions (not the requests
 * raised against them). search matches name/description; is_active is optional.
 */
export const getApprovalFlowListApi = ({
  pageNumber = 1,
  pageSize = 20,
  search = "",
  is_active = "",
} = {}) => {
  const params = new URLSearchParams();
  params.append("pageSize", pageSize);
  params.append("pageNumber", pageNumber);
  params.append("search", search ?? "");
  if (is_active !== "" && is_active !== null && is_active !== undefined) {
    params.append("is_active", is_active);
  }
  return api.get(`/approval-flows/list?${params.toString()}`);
};
